import { Checkbox } from "../ui/checkbox";

export default function AssigneePicker({ users, value = [], onChange, disabled, testid = "assignee-picker" }) {
  const toggle = (id) => onChange(value.includes(id) ? value.filter(x => x !== id) : [...value, id]);
  return (
    <div className="rounded-lg border border-[#E4E7EC] max-h-40 overflow-y-auto divide-y divide-[#E4E7EC]" data-testid={testid}>
      {users.length === 0 && <div className="px-3 py-2 text-[11px] text-neutral-500">No team members on this project yet</div>}
      {users.map(u => (
        <label key={u.id} className={`flex items-center gap-2 px-3 py-1.5 ${disabled ? "opacity-60" : "cursor-pointer hover:bg-neutral-50"}`} data-testid={`${testid}-${u.id}`}>
          <Checkbox checked={value.includes(u.id)} disabled={disabled} onCheckedChange={() => toggle(u.id)} />
          <span className="text-sm">{u.name}</span>
          <span className="text-[10px] font-mono text-neutral-500 ml-auto">{u.role}</span>
        </label>
      ))}
    </div>
  );
}
